<template>
  <div class="upload-video">
    <el-upload
      class="upload-video"
      ref="uploadVideo"
      :action="uploadUrl"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      accept="*"
      :limit="1"
      :headers="headerParams"
      :data="{ dirName: Date.now() }"
      :file-list="videoList"
    >
      <!-- <el-button size="small" type="primary">点击上传</el-button> -->
      <div class="flex-row-space-between">
        <div slot="tip" class="el-upload__tip">请上传附件文件</div>
        <img src="../../../images/update.png" alt="" />
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: ["videoList"],
  data() {
    return {
      uploadUrl: "/api/file/open/upload",
      headerParams: {},
      // 上传成功后视频的路径
      videoUrl: "",
      videoName: "",
    };
  },
  mounted() {
    // this.headerParams.token = this.$cookie.get("token");
  },
  methods: {
    // 从本地保存的上传目录中删除图片路径
    handleRemove(file, fileList) {
      this.videoUrl = "";
      this.$emit("removeVideo");
    },
    handlePreview(file) {
      window.open(file.url, "_blank").loaction;
      // if(this.videoUrl !== "") {
      //     window.open(this.videoUrl, "_blank").location;
      // } else {
      //     console.log(this.videoList);
      //     window.open(this.videoList.url, "_blank").location;
      // }
    },
    beforeUpload(file) {
      console.log(file);
      const isLt100M = file.size / 1024 / 1024 < 50;
      const name = file.name;
      this.videoName = name;
      //   if (
      //     [
      //       "video/mp4",
      //       "video/ogg",
      //       "video/flv",
      //       "video/avi",
      //       "video/wmv",
      //       "video/rmvb",
      //       "video/mov",
      //     ].indexOf(file.type) == -1
      //   ) {
      //     this.$message.error("请上传正确的视频格式");
      //     return false;
      //   }
      if (!isLt100M) {
        this.$message.error("上传文件大小不能超过 50MB!");
      }
      return isLt100M, name;
    },
    handleSuccess(response) {
      console.log(response);
      if (response && response.code === 0) {
        console.log("文件上传成功返回结果：", response.data);
        this.videoUrl = response.data;
        this.$emit("videoUploaded", this.videoUrl, this.videoName);
      }
    },
    clearFiles() {
      this.$refs.uploadVideo.clearFiles();
    },
  },
};
</script>

<style lang="less" scoped>
.upload-video {
  width: 100%;
  font-size: 12px !important;
  img {
    width: 16px !important;
    height: 16px !important;
  }
  .el-upload__tip{
    text-align: left;
    margin-left: 5px;
  }
  /deep/.el-upload-list {
    text-align: left !important;
    margin-left: 20px !important;
  }
 
}
</style>